import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class HideMessage extends WebComponent {

  didMount() {
    this.timer = setTimeout(() => {
      this.element.classList.add("alert-hidden")
    }, 5000);
  }

  willUnmount() {
    this.timer = null;
  }

}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/HideMessage.js